import { AutogenModelEdiRequiredFieldOutboundInvoice, AutogenRowEdiRequiredFieldOutboundInvoice } from "./autogen/AutogenModelEdiRequiredFieldOutboundInvoice";

export class ModelEdiRequiredFieldOutboundInvoice extends AutogenModelEdiRequiredFieldOutboundInvoice<RowEdiRequiredFieldOutboundInvoice> {
	constructor() {
		super(RowEdiRequiredFieldOutboundInvoice);
	}
}

export class RowEdiRequiredFieldOutboundInvoice extends AutogenRowEdiRequiredFieldOutboundInvoice {
}